// src/modules/atendimentoindividual/index.jsx

import React, { useState, useEffect, useCallback } from "react";
import env from "../../config/env.js";
import { useSystemMessagesContext } from "../../contexts/SystemMessagesContext";
import {
  createApiErrorMessage
} from "../../utils/formatadores";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, TableSortLabel,
  Tooltip, Select, MenuItem, InputLabel, FormControl,
  TablePagination, CircularProgress, FormHelperText,
  Grid, Chip, Tabs, Tab, IconButton, Snackbar, Alert, Switch, FormControlLabel
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Print as PrintIcon,
  Close as CloseIcon,
  Person as PersonIcon,
  ThumbUp,
  ThumbDown
} from "@mui/icons-material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';

import api from "../../services/api";
import AcessoRestrito from '../../components/AcessoRestrito';
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

import {
  formatarCPFCNPJLGPD,
  formatarTelefoneLGPD,
  formatarEmailLGPD
} from "../../utils/lgpd";
import axios from "axios";

// Array de tipos de anotações - adicione novos tipos aqui conforme necessário
const tiposAnotacoes = [
  { value: 'observacao', label: 'Observação' },
  { value: 'encaminhamento', label: 'Encaminhamento' },
  { value: 'receituario', label: 'Receituário' },
  { value: 'outro', label: 'Outro' }
  // Adicione novos tipos aqui:
  // { value: 'novo_tipo', label: 'Novo Tipo' },
];

// Array com as formas de pagamento disponíveis
const FORMAS_PAGAMENTO = [
  'Dinheiro',
  'PIX', 
  'Cartão Crédito',
  'Cartão Débito',
  'Boleto',
  'Transferência',
  'Cheque',
  'Outros'
];

export default function AtendimentoIndividual() {
  // Hook do sistema de mensagens
  const { addError, addSuccess } = useSystemMessagesContext();

  const [agendamentos, setAgendamentos] = useState([]);
  const [atendimentos, setAtendimentos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [locais, setLocais] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openAtendimento, setOpenAtendimento] = useState(false);
  const [openFormularioAtendimento, setOpenFormularioAtendimento] = useState(false);
  const [agendamentoAtendimento, setAgendamentoAtendimento] = useState(null);
  const [atendimentoSelecionado, setAtendimentoSelecionado] = useState(null);
  const [agendamentoVisualizar, setAgendamentoVisualizar] = useState(null);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);
  const [openModalPagamento, setOpenModalPagamento] = useState(false);
  const [modalPagamentoContexto, setModalPagamentoContexto] = useState(null); // 'iniciar' ou 'finalizar'
  const [agendamentoParaPagamento, setAgendamentoParaPagamento] = useState(null);
  const [formDataPagamento, setFormDataPagamento] = useState({
    formaPagamento: '',
    parcelado: false,
    numParcelas: 1
  });
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabAtendimento, setActiveTabAtendimento] = useState(0);
  const [activeTabFormularioAtendimento, setActiveTabFormularioAtendimento] = useState(0);
  const [isModoVisualizacao, setIsModoVisualizacao] = useState(false);
  const [dataHoraAtual, setDataHoraAtual] = useState(new Date());
  const [formDataAnotacao, setFormDataAnotacao] = useState({
    tipoAnotacao: '',
    anotacao: ''
  });
  const [ocorrenciasCliente, setOcorrenciasCliente] = useState([]);
  const [formData, setFormData] = useState({
    clienteId: '',
    colaboradorId: '',
    localId: '',
    servicoId: '',
    dataHoraInicio: '',
    horaInicio: '',
    horaFim: '',
    st_codHashEmpresa: '',
    local_execucao: {
      tipo: '',
      local: ''
    }
  });
  const [formErrors, setFormErrors] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState("dataHoraInicio");
  const [order, setOrder] = useState("asc");
  const [filtros, setFiltros] = useState({
    cliente: '',
    colaborador: '',
    local: ''
  });
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [disponibilidadeColaborador, setDisponibilidadeColaborador] = useState([]);
  const [diasSelecionados, setDiasSelecionados] = useState([]);
  const [dataSelecionada, setDataSelecionada] = useState(null);
  const [horariosDisponiveis, setHorariosDisponiveis] = useState([]);
  const [colaboradoresServico, setColaboradoresServico] = useState([]);

  const diasSemana = {
    0: 'Domingo',
    1: 'Segunda-feira',
    2: 'Terça-feira',
    3: 'Quarta-feira',
    4: 'Quinta-feira',
    5: 'Sexta-feira',
    6: 'Sábado'
  };

  // Carregar todos os dados iniciais
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
        
        if (!token || !codHashEmpresa) {
          addError('Token ou código da empresa não encontrado');
          return;
        }

        const headers = {
          'Authorization': `Bearer ${token}`,
          'x-second-key': env.SECOND_SECRET_KEY
        };

        // Buscar clientes
        const resClientes = await api.get('/clientes', { headers });
        setClientes(resClientes.data || []);

        // Buscar colaboradores
        const resColaboradores = await api.get(`/colaboradores?st_codHashEmpresa=${codHashEmpresa}`, { headers });
        let colaboradoresFiltrados = resColaboradores.data || [];
        const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");
        if (usuario.perfil !== "superusuario") {
          colaboradoresFiltrados = colaboradoresFiltrados.filter(colaborador =>
            colaborador.st_codHashEmpresa === codHashEmpresa
          );
        }
        setColaboradores(colaboradoresFiltrados);

        // Buscar locais
        const resLocais = await api.get(`/local?st_codHashEmpresa=${codHashEmpresa}`, { headers });
        setLocais(resLocais.data || []);

        // Buscar serviços
        const resServicos = await api.get('/servicos', { headers });
        if (resServicos.data && resServicos.data.dados) {
          setServicos(resServicos.data.dados);
        } else if (Array.isArray(resServicos.data)) {
          setServicos(resServicos.data);
        } else {
          setServicos([]);
        }

        // Buscar agendamentos
        const resAgendamentos = await api.get('/agendamentos', { headers });
        setAgendamentos(resAgendamentos.data || []);

        // Buscar atendimentos
        const resAtendimentos = await api.get('/atendimentos', { headers });
        setAtendimentos(resAtendimentos.data || []);
      } catch (err) {
        addError(err.response?.data?.message || 'Erro ao carregar dados');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Funções de confirmação
  const confirmarAcao = (mensagem) => {
    return window.confirm(mensagem);
  };

  const handleConfirmarAtendimento = async (agendamento) => {
    const confirmacao = confirmarAcao('Tem certeza que deseja iniciar o atendimento para este cliente?');
    if (confirmacao) {
      // Buscar dados do serviço para verificar se há valor
      try {
        const servico = await buscarDadosServico(agendamento.servicoId);
        if (!servico) {
          addError('Serviço não encontrado');
          return;
        }
        // Abrir modal de pagamento para iniciar atendimento
        setAgendamentoParaPagamento(agendamento);
        setModalPagamentoContexto('iniciar');
        setOpenModalPagamento(true);
      } catch (error) {
        addError(`Erro ao buscar dados do serviço: ${error.message}`);
      }
    }
  };

  const handleConfirmarSalvar = async () => {
    console.log('🔔 [FRONTEND] handleConfirmarSalvar chamado!');
    const confirmacao = confirmarAcao('Tem certeza que deseja salvar este agendamento?');
    console.log('🔔 [FRONTEND] Confirmação do usuário:', confirmacao ? 'SIM' : 'NÃO');
    if (confirmacao) {
      console.log('✅ [FRONTEND] Usuário confirmou. Chamando handleSalvar...');
      await handleSalvar();
    } else {
      console.log('❌ [FRONTEND] Usuário cancelou a operação.');
    }
  };

  const handleConfirmarExcluir = async () => {
    const confirmacao = confirmarAcao('Tem certeza que deseja excluir este agendamento? Esta ação não pode ser desfeita.');
    if (confirmacao) {
      await handleExcluir();
    }
  };

  const handleConfirmarAtualizarStatus = async (novoStatus) => {
    // Confirmar e executar (sem modal de pagamento ao finalizar)
    const confirmacao = confirmarAcao(`Tem certeza que deseja alterar o status do atendimento para "${novoStatus}"?`);
    if (confirmacao) {
      await handleAtualizarStatusAtendimento(novoStatus);
    }
  };

  const handleFecharModalPagamento = () => {
    setOpenModalPagamento(false);
    setModalPagamentoContexto(null);
    setAgendamentoParaPagamento(null);
    setFormDataPagamento({
      formaPagamento: '',
      parcelado: false,
      numParcelas: 1
    });
  };

  const handleProcessarPagamento = async () => {
    if (!formDataPagamento.formaPagamento) {
      addError('Por favor, selecione a forma de pagamento');
      return;
    }

    if (formDataPagamento.parcelado && formDataPagamento.numParcelas < 1) {
      addError('O número de parcelas deve ser pelo menos 1');
      return;
    }

    // Processar apenas para iniciar atendimento
    if (modalPagamentoContexto === 'iniciar') {
      // Iniciar atendimento com pagamento
      const atendimentoCriado = await handleAtendimento(agendamentoParaPagamento, formDataPagamento);
      // Não ocultar a falha: o usuário precisa corrigir o vínculo informado pela API
      // ou tentar novamente sem perder a forma de pagamento selecionada.
      if (atendimentoCriado) {
        handleFecharModalPagamento();
      }
      return;
    }

    handleFecharModalPagamento();
  };

  const handleConfirmarSalvarAnotacao = async () => {
    if (!atendimentoSelecionado) {
      addError('Nenhum atendimento selecionado');
      return;
    }

    if (!formDataAnotacao.tipoAnotacao || !formDataAnotacao.anotacao) {
      addError('Por favor, preencha o tipo e a anotação do atendimento.');
      return;
    }

    const colaborador = colaboradores.find(c => c.id === atendimentoSelecionado.colaboradorId);
    const nomeColaborador = colaborador && colaborador.nome_completo || 'Colaborador';
    const confirmacao = confirmarAcao(`${nomeColaborador}, tem certeza que deseja salvar esta anotação de atendimento?`);
    if (confirmacao) {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const headers = {
          'Authorization': `Bearer ${token}`,
          'x-second-key': env.SECOND_SECRET_KEY
        };

        const atendimentoId = atendimentoSelecionado._id || atendimentoSelecionado.id_atendimento || atendimentoSelecionado.id;
        const payload = {
          atendimento_id: atendimentoId,
          clienteId: atendimentoSelecionado.clienteId,
          colaboradorId: atendimentoSelecionado.colaboradorId,
          servicoId: atendimentoSelecionado.servicoId,
          dataHoraInicio: atendimentoSelecionado.dataHoraInicio,
          data: atendimentoSelecionado.dataHoraInicio ? atendimentoSelecionado.dataHoraInicio.split('T')[0] : new Date().toISOString().split('T')[0],
          tipo: formDataAnotacao.tipoAnotacao,
          texto: `(${nomeColaborador}) ${formDataAnotacao.anotacao}`
        };

        await api.post('/atendimentos/anotacoes', payload, { headers });
        addSuccess('Anotação de atendimento salva com sucesso!');
        setFormDataAnotacao({ tipoAnotacao: '', anotacao: '' });
        await carregarAgendamentos();
        // Recarregar ocorrências do cliente para atualizar o histórico
        if (atendimentoSelecionado && atendimentoSelecionado.clienteId) {
          await buscarOcorrenciasCliente(atendimentoSelecionado.clienteId);
        }
      } catch (error) {
        addError(`Erro ao salvar anotação de atendimento: ${(error.response && error.response.data && error.response.data.message) || error.message}`);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleConfirmarImprimir = () => {
  const confirmacao = confirmarAcao('Tem certeza que deseja imprimir este relatório?');
    if (confirmacao) {
    const printWindow = window.open('', '_blank');
    const cliente = clientes.find(c => c.id === atendimentoSelecionado.clienteId);
    const data = new Date(atendimentoSelecionado.dataHoraInicio);
    const dataFormatada = data.toLocaleDateString('pt-BR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    const horaFormatada = data.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>${cliente && cliente.nome_completo || 'Cliente'}</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 0; 
              padding: 40px;
              line-height: 1.6;
              font-size: 14px;
              display: flex;
              flex-direction: column;
              align-items: center;
              min-height: 100vh;
            }
            .content {
              max-width: 600px;
              width: 100%;
            }
            .header { 
              text-align: center; 
              margin-bottom: 30px; 
              border-bottom: 2px solid #333; 
              padding-bottom: 20px;
            }
            .empresa-nome { 
              font-size: 24px; 
              font-weight: bold; 
              margin-bottom: 10px; 
            }
            .info-row { 
              margin-bottom: 15px; 
            }
            .label { 
              font-weight: bold; 
              display: inline-block; 
              width: 200px; 
            }
            .value { 
              display: inline-block; 
            }
            .anotacao { 
              margin-top: 20px; 
              padding: 15px; 
              border: 1px solid #ccc; 
              background-color: #f9f9f9; 
            }
            .anotacao-tipo { 
              font-weight: bold; 
              color: #333; 
              margin-bottom: 10px; 
            }
            .anotacao-texto { 
              white-space: pre-wrap; 
            }
            @media print {
              body { margin: 20px; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="content">
            <div class="header">
              <div class="empresa-nome">${formDataAnotacao.tipoAnotacao ? formDataAnotacao.tipoAnotacao.toUpperCase() : 'ATENDIMENTO'}</div>
            </div>
            
            <div class="info-row">
              <span class="label">Nome:</span>
              <span class="value">${cliente && cliente.nome_completo || 'N/A'}</span>
            </div>
            
            <div class="info-row">
              <span class="label">Data:</span>
              <span class="value">${dataFormatada}</span>
            </div>
            
            <div class="info-row">
              <span class="label">Horário de Atendimento:</span>
              <span class="value">${horaFormatada}</span>
            </div>
            
            ${formDataAnotacao.tipoAnotacao && formDataAnotacao.anotacao ? `
              <div class="anotacao">
                <div class="anotacao-tipo">Tipo: ${formDataAnotacao.tipoAnotacao}</div>
                <div class="anotacao-texto">${formDataAnotacao.anotacao}</div>
              </div>
            ` : ''}
            
            <div style="margin-top: 50px; text-align: center;">
              <div style="border-top: 1px solid #000; width: 200px; margin: 0 auto 10px auto;"></div>
              <div style="font-weight: bold; margin-bottom: 5px;">Assinatura do Colaborador</div>
              <div style="font-size: 12px; color: #666;">${(() => {
              const colaborador = colaboradores.find(c => c.id === atendimentoSelecionado.colaboradorId);
                return (colaborador && colaborador.nome_completo) || 'Nome do Colaborador';
              })()}</div>
            </div>
            
            <div class="no-print" style="margin-top: 30px; text-align: center;">
              <button onclick="window.print()">Imprimir</button>
              <button onclick="window.close()">Fechar</button>
            </div>
          </div>
        </body>
        </html>
      `);
      printWindow.document.close();
    }
  };

  // Função para criar logs de autenticação removida - agora é feita no backend

  const calcularHoraFim = (horaInicio, servicoId) => {
    if (!horaInicio || !servicoId) return '';

  const servico = servicos.find(s => s.id === servicoId);
    if (!servico || !servico.duracao_minutos) return '';

  const [horas, minutos] = horaInicio.split(':').map(Number);
  const data = new Date();
    data.setHours(horas);
    data.setMinutes(minutos);

    // Adiciona a duração do serviço em minutos
    data.setMinutes(data.getMinutes() + servico.duracao_minutos);

    return `${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}`;
  };

  const handleInputChange = (event) => {
  const { name, value } = event.target;
    setFormData(prev => {
    const newData = { ...prev, [name]: value };

      // Se mudou o serviço, atualiza o local_execucao com os dados do serviço
      if (name === 'servicoId') {
      const servicoSelecionado = servicos.find(s => s.id === value);
        if (servicoSelecionado && servicoSelecionado.local_execucao) {
          newData.local_execucao = {
            ...servicoSelecionado.local_execucao
          };
        }
      }

      // Se mudou o serviço e já tem data selecionada, recalcula os horários
      if (name === 'servicoId' && dataSelecionada) {
      const dia = dataSelecionada.getDay();
      const horarios = calcularHorariosDisponiveis(dia, value);
        setHorariosDisponiveis(horarios);
      }

      return newData;
    });
    setFormErrors(prev => ({ ...prev, [name]: false }));
  };

  const handleNestedInputChange = (campo, subcampo, valor) => {
    setFormData(prev => ({
      ...prev,
      [campo]: {
        ...prev[campo],
        [subcampo]: valor
      }
    }));
  };

  const handleOpenForm = (agendamento = null) => {
    if (agendamento) {
      setFormData({
        clienteId: agendamento.clienteId,
        colaboradorId: agendamento.colaboradorId,
        servicoId: agendamento.servicoId,
        dataHoraInicio: agendamento.dataHoraInicio,
        st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa"),
        local_execucao: {
          tipo: (agendamento.local_execucao && agendamento.local_execucao.tipo) || '',
          local: (agendamento.local_execucao && agendamento.local_execucao.local) || ''
        }
      });
      setAgendamentoSelecionado(agendamento);
    const cliente = clientes.find(c => c.id === agendamento.clienteId);
      setClienteSelecionado(cliente);
      if (agendamento.colaboradorId) {
        buscarDisponibilidadeColaborador(agendamento.colaboradorId);
      }
    } else {
      setFormData({
        clienteId: '',
        colaboradorId: '',
        servicoId: '',
        dataHoraInicio: '',
        st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa"),
        local_execucao: {
          tipo: '',
          local: ''
        }
      });
      setAgendamentoSelecionado(null);
      setClienteSelecionado(null);
      setDisponibilidadeColaborador([]);
      setDiasSelecionados([]);
      setDataSelecionada(null);
      setHorariosDisponiveis([]);
    }
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setFormData({
      clienteId: '',
      colaboradorId: '',
      servicoId: '',
      dataHoraInicio: '',
      st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa"),
      local_execucao: {
        tipo: '',
        local: ''
      }
    });
    setAgendamentoSelecionado(null);
    setClienteSelecionado(null);
    setDisponibilidadeColaborador([]);
    setDiasSelecionados([]);
    setDataSelecionada(null);
    setHorariosDisponiveis([]);
    setFormErrors({});
  };

  const handleOpenDelete = (agendamento) => {
    if (!agendamento) {
      addError('Agendamento inválido');
      return;
    }

    if (!agendamento._id) {
      addError('ID do agendamento inválido');
      return;
    }

    setAgendamentoSelecionado(agendamento);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setAgendamentoSelecionado(null);
  };

  const handleAtendimento = async (agendamento, dadosPagamento = null) => {
    if (!agendamento?._id) {
      addError('Agendamento inválido para iniciar o atendimento.');
      return false;
    }
    setLoading(true);
    const inicioRequisicao = Date.now();
    
    try {
      console.log('═══════════════════════════════════════════════════════════════');
      console.log('🚀 [FRONTEND] ========== INICIAR ATENDIMENTO ==========');
      console.log('═══════════════════════════════════════════════════════════════');
      
      const token = localStorage.getItem("token");
      const st_codHashEmpresa = localStorage.getItem("st_codHashEmpresa");

      if (!token) {
        addError("Token não encontrado");
        setLoading(false);
        return;
      }

      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY,
        'x-codhash-empresa': st_codHashEmpresa
      };

      const payload = {
        clienteId: agendamento.clienteId,
        colaboradorId: agendamento.colaboradorId,
        servicoId: agendamento.servicoId,
        localId: agendamento.localId,
        dataHoraInicio: agendamento.dataHoraInicio,
        dataHoraFim: agendamento.dataHoraFim,
        status: "Aguardando",
        agendamentoId: agendamento._id,
        st_codHashEmpresa: st_codHashEmpresa,
        pedidos: [],
        pagamento: {
          formaPagamento: dadosPagamento?.formaPagamento,
          parcelado: !!dadosPagamento?.parcelado,
          numeroParcelas: dadosPagamento?.parcelado
            ? parseInt(dadosPagamento.numParcelas, 10) || 1
            : 1
        }
      };

      console.log('📤 [FRONTEND] Enviando requisição POST para /api/atendimentos');
      console.log('📦 [FRONTEND] Payload:', JSON.stringify(payload, null, 2));
      console.log('⏱️ [FRONTEND] Início da requisição:', new Date().toISOString());

      const response = await api.post('/atendimentos', payload, { headers });
      
      const tempoResposta = Date.now() - inicioRequisicao;
      console.log('✅ [FRONTEND] Resposta recebida em', tempoResposta, 'ms');
      console.log('📥 [FRONTEND] Response data:', response.data);

      // Recarrega os dados para atualizar a interface
      await carregarAgendamentos();

      // Exibir mensagem com a senha gerada (se disponível)
      if (response.data?.senha) {
        addSuccess(`Atendimento iniciado com sucesso! Senha gerada: ${response.data.senha}`);
      } else {
        addSuccess("Atendimento iniciado com sucesso!");
      }

      return true;

    } catch (error) {
      const tempoDecorrido = Date.now() - inicioRequisicao;
      console.error('❌ [FRONTEND] Erro ao iniciar atendimento:', error);
      console.error('⏱️ [FRONTEND] Tempo decorrido até o erro:', tempoDecorrido, 'ms');
      
      if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
        console.error('⏱️ [FRONTEND] Erro de timeout - requisição demorou mais que o esperado');
        addError('O servidor demorou muito para responder. O atendimento pode ter sido criado. Verifique a lista de atendimentos.');
      } else if (error.message?.includes('NS_BINDING_ABORTED') || error.code === 'ERR_CANCELED') {
        console.error('🚫 [FRONTEND] Requisição foi cancelada/abortada');
        addError('A requisição foi cancelada. Isso pode ocorrer se o Redis estiver lento. Verifique a lista de atendimentos.');
      } else {
        const mensagemErro = error.error || error.response?.data?.error || error.response?.data?.message || error.message || 'Erro desconhecido';
        console.error('📋 [FRONTEND] Detalhes do erro:', {
          message: mensagemErro,
          status: error.response?.status,
          data: error.response?.data
        });
        addError(`Erro ao iniciar atendimento: ${mensagemErro}`);
      }
      return false;
    } finally {
      setLoading(false);
      console.log('═══════════════════════════════════════════════════════════════');
    }
  };

  const handleCloseAtendimento = () => {
    setOpenAtendimento(false);
    setAgendamentoAtendimento(null);
    setActiveTabAtendimento(0);
  };

  const handleOpenFormularioAtendimento = async (agendamento, atendimentoInformado = null) => {
  const atendimento = atendimentoInformado || atendimentos.find(a => a.agendamentoId === agendamento._id);
    if (atendimento) {
      setAtendimentoSelecionado(atendimento);
      setOpenFormularioAtendimento(true);
      setActiveTabFormularioAtendimento(2); // Abre na guia ATENDIMENTO
      setIsModoVisualizacao(false); // Desativa o modo de visualização

      // Buscar ocorrências do cliente
      if (atendimento.clienteId) {
        await buscarOcorrenciasCliente(atendimento.clienteId);
      }
      // Log de auditoria removido - agora é feito no backend
    }
  };

  const handleChamarAtendimento = async (agendamento) => {
    const atendimento = atendimentos.find(a => a.agendamentoId === agendamento._id);
    const atendimentoId = atendimento?._id || atendimento?.id_atendimento || atendimento?.id;

    if (!atendimentoId) {
      addError('Atendimento não encontrado para realizar a chamada.');
      return;
    }
    if (atendimento.status !== 'Aguardando') {
      addError(`Não é possível chamar um atendimento com status "${atendimento.status || 'não informado'}".`);
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const stCodHashEmpresa = localStorage.getItem('st_codHashEmpresa');

      const response = await api.patch(
        `/atendimentos/${atendimentoId}`,
        { status: 'Chamando' },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'x-second-key': env.SECOND_SECRET_KEY,
            'x-codhash-empresa': stCodHashEmpresa
          }
        }
      );

      const atendimentoAtualizado = response.data?.atendimento;
      if (!atendimentoAtualizado?.id_atendimento && !atendimentoAtualizado?._id && !atendimentoAtualizado?.id) {
        throw new Error('O servidor não confirmou a atualização do atendimento.');
      }

      // Reflete a confirmação do backend imediatamente; a recarga abaixo mantém
      // a lista sincronizada caso existam alterações concorrentes.
      setAtendimentos((anteriores) => anteriores.map((item) => {
        const idItem = item._id || item.id_atendimento || item.id;
        return String(idItem) === String(atendimentoId)
          ? { ...item, ...atendimentoAtualizado, status: 'Chamando' }
          : item;
      }));

      addSuccess('Paciente chamado no painel de atendimento.');
      await carregarAgendamentos();
      return { ...atendimento, ...atendimentoAtualizado, status: 'Chamando' };
    } catch (error) {
      const mensagemErro = error.response?.data?.error || error.response?.data?.message || error.message;
      addError(`Erro ao chamar paciente: ${mensagemErro}`);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const handleAbrirAtendimentoEChamar = async (agendamento) => {
    const atendimento = atendimentos.find(a => a.agendamentoId === agendamento._id);
    if (!atendimento) {
      addError('Atendimento não encontrado para abrir o formulário.');
      return;
    }

    // A tela de atendimento deve responder ao clique imediatamente. A chamada
    // do painel continua sendo confirmada pelo backend em seguida.
    handleOpenFormularioAtendimento(agendamento, atendimento);

    const atendimentoChamado = await handleChamarAtendimento(agendamento);
    if (atendimentoChamado) {
      setAtendimentoSelecionado(atendimentoChamado);
    }
  };

  const handleCloseFormularioAtendimento = () => {
    setOpenFormularioAtendimento(false);
    setAtendimentoSelecionado(null);
    setOcorrenciasCliente([]);
    setIsModoVisualizacao(false); // Reseta o modo de visualização
  };

  const handleVisualizarAtendimento = async (agendamento) => {
  const atendimento = atendimentos.find(a => a.agendamentoId === agendamento._id);
    if (atendimento) {
      setAtendimentoSelecionado(atendimento);
      setOpenFormularioAtendimento(true);
      setActiveTabFormularioAtendimento(0); // Sempre abre na guia Informações
      setIsModoVisualizacao(true); // Ativa o modo de visualização

      // Buscar ocorrências do cliente
      if (atendimento.clienteId) {
        await buscarOcorrenciasCliente(atendimento.clienteId);
      }
      // Log de auditoria removido - agora é feito no backend
    }
  };

  const buscarOcorrenciasCliente = async (clienteId) => {
    try {
    const response = await api.get(`/atendimentos/anotacoes/cliente/${clienteId}`);

      if (response.data && Array.isArray(response.data)) {
        setOcorrenciasCliente(response.data);
      } else {
        setOcorrenciasCliente([]);
      }

      return response.data && response.data.map((ocorrencia, index) => {
      const dataFormatada = ocorrencia.criadoEm
          ? format(parseISO(ocorrencia.criadoEm), 'dd/MM/yyyy HH:mm', { locale: ptBR })
          : 'Data não informada';

        return `${index + 1}. [${dataFormatada}] ${ocorrencia.tipo || 'Tipo não informado'}: ${ocorrencia.texto || 'Texto não informado'}`;
      }).join('\n\n') || '';
    } catch (error) {
      console.error('Erro ao buscar ocorrências do cliente:', error);
      setOcorrenciasCliente([]);
      return '';
    }
  };

  const formatarHistoricoOcorrencias = () => {
    if (!ocorrenciasCliente || ocorrenciasCliente.length === 0) {
      return 'Nenhuma ocorrência encontrada.';
    }

    return ocorrenciasCliente.map((ocorrencia, index) => {
    const dataFormatada = ocorrencia.criadoEm
        ? format(parseISO(ocorrencia.criadoEm), 'dd/MM/yyyy HH:mm', { locale: ptBR })
        : 'Data não informada';

      return `${index + 1}. [${dataFormatada}] ${ocorrencia.tipo || 'Tipo não informado'}: ${ocorrencia.texto || 'Texto não informado'}`;
    }).join('\n\n');
  };

  const handleSalvarAnotacao = async () => {
    if (!atendimentoSelecionado || !formDataAnotacao.tipoAnotacao || !formDataAnotacao.anotacao) {
      addError('Por favor, preencha o tipo e a anotação antes de salvar.');
      return;
    }

    // Debug: verificar o ID do atendimento

    setLoading(true);
    try {
    const payload = {
        atendimento_id: atendimentoSelecionado.id_atendimento,
        clienteId: atendimentoSelecionado.clienteId,
        colaboradorId: atendimentoSelecionado.colaboradorId,
        servicoId: atendimentoSelecionado.servicoId,
        dataHoraInicio: atendimentoSelecionado.dataHoraInicio,
        data: atendimentoSelecionado.dataHoraInicio.split('T')[0], // Extrai apenas a data
        tipo: formDataAnotacao.tipoAnotacao,
        texto: formDataAnotacao.anotacao
      };

    const response = await api.post('/atendimentos/anotacoes', payload);

      addSuccess('Anotação salva com sucesso!');
      setFormDataAnotacao({ tipoAnotacao: '', anotacao: '' });
      carregarAgendamentos();
    } catch (error) {
      addError(`Erro ao salvar anotação: ${error.response && error.response.data && error.response.data.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Função para buscar dados do serviço e obter o valor do colaborador
  const buscarDadosServico = async (servicoId) => {
    try {
    const response = await api.get(`/servicos/${servicoId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar dados do serviço:', error);
      throw error;
    }
  };

  const handleAtualizarStatusAtendimento = async (novoStatus, dadosPagamento = null) => {
    if (!atendimentoSelecionado) return;

    const atendimentoId = atendimentoSelecionado._id || atendimentoSelecionado.id_atendimento || atendimentoSelecionado.id;
    if (!atendimentoId) {
      addError('ID do atendimento inválido');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const st_codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY,
        'x-codhash-empresa': st_codHashEmpresa
      };

      const payload = {
        status: novoStatus
      };

      await api.patch(`/atendimentos/${atendimentoId}`, payload, { headers });
      addSuccess('Status do atendimento atualizado com sucesso!');
      
      // Recarrega os dados para atualizar a interface
      await carregarAgendamentos();
    } catch (error) {
      addError(`Erro ao atualizar status: ${error.response && error.response.data && error.response.data.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChangeAtendimento = (event, newValue) => {
    setActiveTabAtendimento(newValue);
  };

  const handleTabChangeFormularioAtendimento = (event, newValue) => {
    setActiveTabFormularioAtendimento(newValue);
  };

  const handleAnotacaoChange = (event) => {
  const { name, value } = event.target;
    setFormDataAnotacao(prev => ({ ...prev, [name]: value }));
  };

  // Validação
  const validar = () => {
    const errors = {};
    if (!formData.clienteId) errors.clienteId = true;
    if (!formData.colaboradorId) errors.colaboradorId = true;
    if (!formData.servicoId) errors.servicoId = true;
    if (!formData.dataHoraInicio) errors.dataHoraInicio = true;

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Salvar (POST/PUT)
  const handleSalvar = async () => {
    console.log('═══════════════════════════════════════════════════════════════');
    console.log('🚀 [FRONTEND] ========== INÍCIO handleSalvar ==========');
    console.log('═══════════════════════════════════════════════════════════════');
    console.log('📋 [FRONTEND] formData completo:', JSON.stringify(formData, null, 2));
    console.log('📋 [FRONTEND] formData.clienteId:', formData.clienteId, '(tipo:', typeof formData.clienteId, ')');
    console.log('📋 [FRONTEND] formData.colaboradorId:', formData.colaboradorId, '(tipo:', typeof formData.colaboradorId, ')');
    console.log('📋 [FRONTEND] formData.servicoId:', formData.servicoId, '(tipo:', typeof formData.servicoId, ')');
    console.log('📋 [FRONTEND] formData.dataHoraInicio:', formData.dataHoraInicio, '(tipo:', typeof formData.dataHoraInicio, ')');
    console.log('📋 [FRONTEND] formData.local_execucao:', JSON.stringify(formData.local_execucao, null, 2));
    console.log('📋 [FRONTEND] formData.observacoes:', formData.observacoes, '(tipo:', typeof formData.observacoes, ')');
    console.log('📋 [FRONTEND] formData.status:', formData.status, '(tipo:', typeof formData.status, ')');
    console.log('📋 [FRONTEND] formData.st_codHashEmpresa:', formData.st_codHashEmpresa);
    console.log('📋 [FRONTEND] agendamentoSelecionado:', agendamentoSelecionado ? 'SIM (atualização)' : 'NÃO (criação)');
    console.log('📋 [FRONTEND] Array servicos disponível:', servicos ? `${servicos.length} serviços` : 'NULL');
    console.log('📋 [FRONTEND] Array clientes disponível:', clientes ? `${clientes.length} clientes` : 'NULL');
    console.log('📋 [FRONTEND] Array colaboradores disponível:', colaboradores ? `${colaboradores.length} colaboradores` : 'NULL');
    
    console.log('🔍 [FRONTEND] Executando validação...');
    const validacaoResultado = validar();
    console.log('🔍 [FRONTEND] Resultado da validação:', validacaoResultado ? '✅ PASSOU' : '❌ FALHOU');
    
    if (!validacaoResultado) {
      console.log('❌ [FRONTEND] Validação falhou! Abortando operação.');
      console.log('═══════════════════════════════════════════════════════════════');
      return;
    }
    
    console.log('✅ [FRONTEND] Validação passou! Continuando...');
    setLoading(true);
    try {
      console.log('📝 [FRONTEND] Iniciando processo de salvar agendamento...');

      // Busca o serviço selecionado para obter o localId
      console.log('🔍 [FRONTEND] Buscando serviço selecionado...');
      console.log('   - servicoId para buscar:', formData.servicoId);
      console.log('   - Total de serviços disponíveis:', servicos?.length || 0);
    const servicoSelecionado = servicos.find(s => s.id === formData.servicoId);
      console.log('   - Serviço encontrado:', servicoSelecionado ? 'SIM' : 'NÃO');
      if (servicoSelecionado) {
        console.log('   - Serviço:', JSON.stringify({
          id: servicoSelecionado.id,
          nome: servicoSelecionado.nome,
          duracao_minutos: servicoSelecionado.duracao_minutos,
          local_execucao: servicoSelecionado.local_execucao
        }, null, 2));
      }

      // Verifica se o serviço tem local definido
      console.log('🔍 [FRONTEND] Verificando local de execução do serviço...');
      console.log('   - servicoSelecionado existe:', !!servicoSelecionado);
      console.log('   - servicoSelecionado.local_execucao existe:', !!servicoSelecionado?.local_execucao);
      console.log('   - servicoSelecionado.local_execucao.id existe:', !!servicoSelecionado?.local_execucao?.id);
      
      if (!servicoSelecionado || !servicoSelecionado.local_execucao || !servicoSelecionado.local_execucao.id) {
        console.error('❌ [FRONTEND] Serviço não possui local válido!');
        console.error('   - servicoSelecionado:', servicoSelecionado);
        console.error('   - local_execucao:', servicoSelecionado?.local_execucao);
        addError('O serviço selecionado não possui um local válido');
        setLoading(false);
        return;
      }
      
      console.log('✅ [FRONTEND] Local de execução válido encontrado!');
      console.log('   - local_execucao.id:', servicoSelecionado.local_execucao.id);
      console.log('   - local_execucao.tipo:', servicoSelecionado.local_execucao.tipo);

      // Usa exatamente o horário selecionado na tela (sem conversão UTC)
      console.log('📅 [FRONTEND] Processando data/hora de início...');
    const dataHoraInicio = formData.dataHoraInicio;
      console.log('   - dataHoraInicio (original):', dataHoraInicio);
      console.log('   - Tipo:', typeof dataHoraInicio);

      // Calcula a data de fim usando a mesma string local com timezone offset
      // Extrai os componentes da data de início
      console.log('📅 [FRONTEND] Extraindo componentes da data/hora...');
    const dataInicioParts = dataHoraInicio.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})([+-]\d{2}:\d{2})/);
      console.log('   - Resultado do match:', dataInicioParts);
      
      if (!dataInicioParts) {
        console.error('❌ [FRONTEND] Formato de data inválido!');
        console.error('   - dataHoraInicio:', dataHoraInicio);
        addError('Formato de data inválido');
        setLoading(false);
        return;
      }

      console.log('✅ [FRONTEND] Data/hora parseada com sucesso!');
    const [, ano, mes, dia, hora, minuto, segundo, timezoneOffset] = dataInicioParts;
      console.log('   - Ano:', ano);
      console.log('   - Mês:', mes);
      console.log('   - Dia:', dia);
      console.log('   - Hora:', hora);
      console.log('   - Minuto:', minuto);
      console.log('   - Segundo:', segundo);
      console.log('   - Timezone offset:', timezoneOffset);

      // Cria a data de fim adicionando a duração
      console.log('📅 [FRONTEND] Criando datas de início e fim...');
      console.log('   - Duração do serviço (minutos):', servicoSelecionado.duracao_minutos);
    const dataInicio = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia), parseInt(hora), parseInt(minuto), parseInt(segundo));
      console.log('   - dataInicio criada:', dataInicio.toISOString());
    const dataFim = new Date(dataInicio.getTime() + servicoSelecionado.duracao_minutos * 60000);
      console.log('   - dataFim criada:', dataFim.toISOString());

      // Formata a data de fim no mesmo formato local com timezone offset
    const anoFim = dataFim.getFullYear();
    const mesFim = String(dataFim.getMonth() + 1).padStart(2, '0');
    const diaFim = String(dataFim.getDate()).padStart(2, '0');
    const horaFim = String(dataFim.getHours()).padStart(2, '0');
    const minutoFim = String(dataFim.getMinutes()).padStart(2, '0');
    const segundoFim = String(dataFim.getSeconds()).padStart(2, '0');

    const dataHoraFim = `${anoFim}-${mesFim}-${diaFim}T${horaFim}:${minutoFim}:${segundoFim}${timezoneOffset}`;

      // Formata os dados para o formato esperado pela API
      // NOTA: Não enviar dataHoraFim - o backend calcula isso baseado na duração do serviço
      console.log('📦 [FRONTEND] Montando payload dadosAgendamento...');
      
      // Obter o tipo original
      const tipoOriginal = formData.local_execucao?.tipo || servicoSelecionado.local_execucao?.tipo || 'presencial';
      const tipoNormalizado = tipoOriginal.toLowerCase();
      
      // VALIDAR: O enum do backend só aceita 'presencial', 'online' ou 'hibrido'
      // Se o tipo não for válido (ex: "sala", "consultorio", etc), usar 'presencial' como padrão
      const tiposValidos = ['presencial', 'online', 'hibrido'];
      let tipoFinal = tipoNormalizado;
      
      if (!tiposValidos.includes(tipoFinal)) {
        console.warn(`⚠️ [FRONTEND] Tipo inválido "${tipoNormalizado}" detectado! Usando 'presencial' como padrão.`);
        console.warn('   - Tipo original:', tipoOriginal);
        console.warn('   - Serviço local_execucao:', JSON.stringify(servicoSelecionado.local_execucao, null, 2));
        tipoFinal = 'presencial'; // Padrão seguro
      }
      
      console.log('   - Tipo original:', tipoOriginal);
      console.log('   - Tipo normalizado:', tipoNormalizado);
      console.log('   - Tipo final (validado):', tipoFinal);
      
    const dadosAgendamento = {
        clienteId: parseInt(formData.clienteId),
        colaboradorId: parseInt(formData.colaboradorId),
        servicoId: formData.servicoId,
        localId: servicoSelecionado.local_execucao.id,
        dataHoraInicio: dataHoraInicio,
        // dataHoraFim removido - backend calcula isso
        st_codHashEmpresa: formData.st_codHashEmpresa,
        // Campos adicionais que o backend espera
        // Normalizar o tipo para minúsculo (backend espera: 'presencial', 'online', 'hibrido')
        // IMPORTANTE: Validar que o tipo seja um dos valores permitidos
        local_execucao: {
          tipo: tipoFinal, // Usar tipoFinal que foi validado
          local: formData.local_execucao?.local || servicoSelecionado.local_execucao?.local || ''
        },
        observacoes: formData.observacoes || '',
        status: formData.status || 'Agendado'
      };
      
      console.log('📦 [FRONTEND] Payload montado:');
      console.log(JSON.stringify(dadosAgendamento, null, 2));
      console.log('   - clienteId:', dadosAgendamento.clienteId, '(tipo:', typeof dadosAgendamento.clienteId, ')');
      console.log('   - colaboradorId:', dadosAgendamento.colaboradorId, '(tipo:', typeof dadosAgendamento.colaboradorId, ')');
      console.log('   - servicoId:', dadosAgendamento.servicoId, '(tipo:', typeof dadosAgendamento.servicoId, ')');
      console.log('   - localId:', dadosAgendamento.localId, '(tipo:', typeof dadosAgendamento.localId, ')');
      console.log('   - dataHoraInicio:', dadosAgendamento.dataHoraInicio, '(tipo:', typeof dadosAgendamento.dataHoraInicio, ')');
      console.log('   - st_codHashEmpresa:', dadosAgendamento.st_codHashEmpresa);
      console.log('   - local_execucao:', JSON.stringify(dadosAgendamento.local_execucao, null, 2));
      console.log('   - observacoes:', dadosAgendamento.observacoes, '(tipo:', typeof dadosAgendamento.observacoes, ')');
      console.log('   - status:', dadosAgendamento.status, '(tipo:', typeof dadosAgendamento.status, ')');

      if (agendamentoSelecionado) {
        // Atualização (PATCH) - usando PATCH em vez de PUT
        const agendamentoId = agendamentoSelecionado._id || agendamentoSelecionado.id;
        const token = localStorage.getItem("token");
        const headers = {
          'Authorization': `Bearer ${token}`,
          'x-second-key': env.SECOND_SECRET_KEY
        };
        await api.patch(`/agendamentos/${agendamentoId}`, dadosAgendamento, { headers });
        addSuccess('Agendamento atualizado com sucesso!');
        handleCloseForm();
        await carregarAgendamentos();
      } else {
        // Criação (POST)
        console.log('═══════════════════════════════════════════════════════════════');
        console.log('🔄 [FRONTEND] ========== CRIAÇÃO DE AGENDAMENTO ==========');
        console.log('═══════════════════════════════════════════════════════════════');
        
        const token = localStorage.getItem("token");
        const st_codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
        console.log('🔑 [FRONTEND] Obtendo credenciais...');
        console.log('   - Token existe:', !!token);
        console.log('   - Token length:', token?.length || 0);
        console.log('   - st_codHashEmpresa:', st_codHashEmpresa);
        
        const headers = {
          'Authorization': `Bearer ${token}`,
          'x-second-key': env.SECOND_SECRET_KEY,
          'x-codhash-empresa': st_codHashEmpresa
        };
        
        console.log('🔑 [FRONTEND] Headers montados:');
        console.log('   - Authorization:', token ? 'Bearer *** (presente)' : 'AUSENTE');
        console.log('   - x-second-key:', env.SECOND_SECRET_KEY ? '*** (presente)' : 'AUSENTE');
        console.log('   - x-codhash-empresa:', st_codHashEmpresa || 'AUSENTE');
        
        // Log detalhado antes da requisição
        console.log('📤 [FRONTEND] Preparando requisição POST para /api/agendamentos...');
        console.log('📦 [FRONTEND] Payload completo:', JSON.stringify(dadosAgendamento, null, 2));
        console.log('📋 [FRONTEND] Resumo do payload:');
        console.log('   - clienteId:', dadosAgendamento.clienteId, '(tipo:', typeof dadosAgendamento.clienteId, ')');
        console.log('   - colaboradorId:', dadosAgendamento.colaboradorId, '(tipo:', typeof dadosAgendamento.colaboradorId, ')');
        console.log('   - servicoId:', dadosAgendamento.servicoId, '(tipo:', typeof dadosAgendamento.servicoId, ')');
        console.log('   - localId:', dadosAgendamento.localId, '(tipo:', typeof dadosAgendamento.localId, ')');
        console.log('   - dataHoraInicio:', dadosAgendamento.dataHoraInicio);
        console.log('   - st_codHashEmpresa:', dadosAgendamento.st_codHashEmpresa);
        console.log('   - local_execucao:', JSON.stringify(dadosAgendamento.local_execucao, null, 2));
        console.log('   - observacoes:', dadosAgendamento.observacoes, '(tipo:', typeof dadosAgendamento.observacoes, ')');
        console.log('   - status:', dadosAgendamento.status, '(tipo:', typeof dadosAgendamento.status, ')');
        
        console.log('🌐 [FRONTEND] Enviando requisição HTTP POST...');
        console.log('   - URL:', '/api/agendamentos');
        console.log('   - Método: POST');
        console.log('   - Timestamp:', new Date().toISOString());
        
        const inicioRequisicao = Date.now();
        console.log('⏱️ [FRONTEND] Início da requisição registrado:', inicioRequisicao);
        console.log('🚨 [FRONTEND] ANTES DE CHAMAR API.POST - VERIFIQUE ESTE LOG!');
        console.log('🚨 [FRONTEND] Se este log não aparecer, há um problema antes da requisição');
        try {
          console.log('🚨 [FRONTEND] DENTRO DO TRY - VAI CHAMAR api.post AGORA!');
          const response = await api.post('/agendamentos', dadosAgendamento, { headers });
          console.log('🚨 [FRONTEND] RESPOSTA RECEBIDA DA API!');
          const tempoResposta = Date.now() - inicioRequisicao;
          
          console.log('✅ [FRONTEND] Requisição bem-sucedida!');
          console.log('   - Tempo de resposta:', tempoResposta, 'ms');
          console.log('   - Status HTTP:', response.status);
          console.log('   - Response headers:', response.headers);
          console.log('📥 [FRONTEND] Response data completo:', JSON.stringify(response.data, null, 2));
          console.log('   - Mensagem:', response.data?.mensagem || response.data?.message || 'N/A');
          console.log('   - ID do agendamento:', response.data?.dados?.id || response.data?.id || 'N/A');

        // Busca informações para o log
      const cliente = clientes.find(c => c.id === parseInt(formData.clienteId));
      const colaborador = colaboradores.find(c => c.id === parseInt(formData.colaboradorId));
      const servico = servicos.find(s => s.id === formData.servicoId);

      const descricao = `Criou agendamento para cliente ${cliente && colaborador.nome_completo || 'N/A'}, colaborador ${colaborador && colaborador.nome_completo || 'N/A'}, serviço ${(servico && servico.nome) || 'N/A'} em ${format(new Date(dataHoraInicio), 'dd/MM/yyyy HH:mm')}`;

          console.log('✅ [FRONTEND] Fechando formulário e recarregando agendamentos...');
          handleCloseForm();
          await carregarAgendamentos();
          console.log('✅ [FRONTEND] Processo concluído com sucesso!');
          console.log('═══════════════════════════════════════════════════════════════');
        } catch (postError) {
          console.error('🚨🚨🚨 [FRONTEND] ERRO CAPTURADO NO CATCH! 🚨🚨🚨');
          const tempoErro = Date.now() - inicioRequisicao;
          console.error('═══════════════════════════════════════════════════════════════');
          console.error('❌ [FRONTEND] ========== ERRO AO CRIAR AGENDAMENTO ==========');
          console.error('═══════════════════════════════════════════════════════════════');
          console.error('⏱️ [FRONTEND] Tempo até o erro:', tempoErro, 'ms');
          console.error('❌ [FRONTEND] Erro completo:', postError);
          console.error('❌ [FRONTEND] Error name:', postError.name);
          console.error('❌ [FRONTEND] Error message:', postError.message);
          console.error('❌ [FRONTEND] Error code:', postError.code);
          console.error('❌ [FRONTEND] Error stack:', postError.stack);
          
          if (postError.response) {
            console.error('📥 [FRONTEND] Error response existe!');
            console.error('   - Status:', postError.response.status);
            console.error('   - Status Text:', postError.response.statusText);
            console.error('   - Headers:', JSON.stringify(postError.response.headers, null, 2));
            console.error('   - Data:', JSON.stringify(postError.response.data, null, 2));
            
            if (postError.response.data) {
              console.error('   - erro:', postError.response.data.erro || 'N/A');
              console.error('   - error:', postError.response.data.error || 'N/A');
              console.error('   - message:', postError.response.data.message || 'N/A');
              console.error('   - detalhes:', postError.response.data.detalhes || 'N/A');
            }
          } else {
            console.error('⚠️ [FRONTEND] Error response NÃO existe (erro de rede ou antes da requisição)');
          }
          
          if (postError.request) {
            console.error('📤 [FRONTEND] Request que causou o erro:', {
              method: postError.request.method,
              url: postError.request.url,
              headers: postError.request.headers
            });
          }
          
          console.error('═══════════════════════════════════════════════════════════════');
          
          throw postError; // Re-lança o erro para ser capturado pelo catch externo
        }
      }
    } catch (err) {
      console.error('❌ [FRONTEND] Erro geral ao salvar agendamento:', err);
      console.error('❌ [FRONTEND] Error response:', err.response);
      console.error('❌ [FRONTEND] Error response data:', err.response?.data);
      console.error('❌ [FRONTEND] Error response status:', err.response?.status);
      
    const mensagemErro = (err.response && err.response.data && err.response.data.message) ||
        (err.response && err.response.data && err.response.data.error) ||
        (err.response && err.response.data && err.response.data.erro) ||
          (err.response && err.response.data && err.response.data.detalhes) ||
          err.message ||
        'Erro ao salvar agendamento';
      
      console.error('❌ [FRONTEND] Mensagem de erro final:', mensagemErro);
      addError(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  // Excluir
  const handleExcluir = async () => {
    if (!agendamentoSelecionado) {
      addError('Nenhum agendamento selecionado para exclusão');
      return;
    }

    const agendamentoId = agendamentoSelecionado._id || agendamentoSelecionado.id;
    if (!agendamentoId) {
      addError('ID do agendamento inválido');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };
      
      await api.delete(`/agendamentos/${agendamentoId}`, { headers });
      addSuccess('Agendamento excluído com sucesso!');
      handleCloseDelete();
      await carregarAgendamentos();
    } catch (err) {
      const mensagemErro = (err.response && err.response.data && err.response.data.message) ||
        (err.response && err.response.data && err.response.data.error) ||
        (err.response && err.response.data && err.response.data.erro) ||
        'Erro ao excluir agendamento';
      addError(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  // Carregar agendamentos
  const carregarAgendamentos = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

      const res = await api.get('/agendamentos', { headers });
      setAgendamentos(res.data || []);

      // Também recarrega os atendimentos
      const resAtendimentos = await api.get('/atendimentos', { headers });
      setAtendimentos(resAtendimentos.data || []);
    } catch (err) {
      const mensagemErro = (err.response && err.response.data && err.response.data.message) ||
        (err.response && err.response.data && err.response.data.error) ||
        (err.response && err.response.data && err.response.data.erro) ||
        'Erro ao carregar agendamentos';
      addError(mensagemErro);
    }
  }, [addError]);

  const buscarDisponibilidadeColaborador = useCallback(async (colaboradorId) => {
    try {
    const res = await api.get(`/disponibilidade/${colaboradorId}`);
      if (res.data && Array.isArray(res.data)) {
        // Formata os dados da disponibilidade
      const disponibilidadeFormatada = res.data.map(disp => ({
          dia: disp.dia,
          inicio: disp.inicio.substring(0, 5), // Remove os segundos
          fim: disp.fim.substring(0, 5) // Remove os segundos
        }));
        setDisponibilidadeColaborador(disponibilidadeFormatada);
      } else {
        setDisponibilidadeColaborador([]);
      }
      // Log de auditoria removido - agora é feito no backend
    } catch (error) {
      console.error('Erro ao buscar disponibilidade do colaborador:', error);
      setDisponibilidadeColaborador([]);
    }
  }, []);

  const calcularHorariosDisponiveis = useCallback((dia, servicoId) => {
    if (!formData.colaboradorId || !dataSelecionada) return [];

  const servico = servicos.find(s => s.id === servicoId);
    if (!servico) return [];

  const disponibilidade = disponibilidadeColaborador.find(d => d.dia === dia);
    if (!disponibilidade) return [];

  const horarios = [];
  const inicio = new Date();
    inicio.setHours(parseInt(disponibilidade.inicio.split(':')[0]));
    inicio.setMinutes(parseInt(disponibilidade.inicio.split(':')[1]));

  const fim = new Date();
    fim.setHours(parseInt(disponibilidade.fim.split(':')[0]));
    fim.setMinutes(parseInt(disponibilidade.fim.split(':')[1]));

  const intervalo = servico.duracao || 30; // minutos

    while (inicio < fim) {
    const horarioInicio = `${inicio.getHours().toString().padStart(2, '0')}:${inicio.getMinutes().toString().padStart(2, '0')}`;

      // Verifica se há conflito com agendamentos existentes
    const agendamentoConflitante = agendamentos.find(ag =>
        ag.colaboradorId === formData.colaboradorId &&
        ag.dataHoraInicio &&
        ag.dataHoraInicio.includes(dataSelecionada.toISOString().split('T')[0]) &&
        ag.dataHoraInicio.includes(horarioInicio)
      );

      // Adiciona todos os horários, mas marca os ocupados
      horarios.push({
        horario: horarioInicio,
        disponivel: !agendamentoConflitante
      });

      inicio.setMinutes(inicio.getMinutes() + intervalo);
    }

    return horarios;
  }, [disponibilidadeColaborador, servicos, agendamentos, formData.colaboradorId, dataSelecionada]);

  const handleColaboradorChange = async (e) => {
  const colaboradorId = e.target.value;
    setFormData(prev => ({ ...prev, colaboradorId }));

    // Limpa os estados relacionados à disponibilidade
    setDisponibilidadeColaborador([]);
    setDiasSelecionados([]);
    setDataSelecionada(null);
    setHorariosDisponiveis([]);

    if (colaboradorId) {
      try {
      const res = await api.get(`/disponibilidade/${colaboradorId}`);
        if (res.data && Array.isArray(res.data)) {
          // Formata os dados da disponibilidade
        const disponibilidadeFormatada = res.data.map(disp => ({
            dia: disp.dia,
            inicio: disp.inicio.substring(0, 5), // Remove os segundos
            fim: disp.fim.substring(0, 5) // Remove os segundos
          }));
          setDisponibilidadeColaborador(disponibilidadeFormatada);
        } else {
          setDisponibilidadeColaborador([]);
        }
      } catch (error) {
        console.error('Erro ao buscar disponibilidade do colaborador:', error);
        setDisponibilidadeColaborador([]);
      }
    }
  };

  const handleClienteChange = (e) => {
  const clienteId = e.target.value;
    setFormData(prev => ({ ...prev, clienteId }));
  const cliente = clientes.find(c => c.id === parseInt(clienteId));
    setClienteSelecionado(cliente);
  };

  const handleDiaSelecionado = (dia) => {
    setDiasSelecionados(prev => {
    const novosDias = prev.includes(dia)
        ? prev.filter(d => d !== dia)
        : [...prev, dia];

      // Se tem data selecionada e o dia da data não está mais nos dias selecionados,
      // limpa a data e os horários
      if (dataSelecionada && !novosDias.includes(dataSelecionada.getDay())) {
        setDataSelecionada(null);
        setHorariosDisponiveis([]);
        setFormData(prev => ({ ...prev, dataHoraInicio: '' }));
      }

      return novosDias;
    });
  };

  const handleDataChange = (data) => {
    setDataSelecionada(data);
    if (data && formData.servicoId) {
      const dia = data.getDay();
      const horarios = calcularHorariosDisponiveis(dia, formData.servicoId);
        setHorariosDisponiveis(horarios);
      } else {
        setHorariosDisponiveis([]);
      }
    };

  const handleRequestSort = (property) => {
    const isAsc = order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
      setFiltros(prev => ({ ...prev, [name]: value }));
      setPage(0);
    };

    // Função para verificar se um agendamento já tem atendimento
  const verificarAtendimentoExistente = (agendamentoId) => {
      return atendimentos.some(atendimento => atendimento.agendamentoId === agendamentoId);
    };

  const obterAtendimento = (agendamentoId) => {
      return atendimentos.find(atendimento => atendimento.agendamentoId === agendamentoId);
    };

  const obterStatusAtendimento = (agendamentoId) => {
    const atendimento = obterAtendimento(agendamentoId);
      return atendimento && atendimento.status || null;
    };

  const isAtendimentoBloqueado = (agendamentoId) => {
    const status = obterStatusAtendimento(agendamentoId);
      return status === "Atendido" || status === "Cancelado" || status === "Desistente";
    };

    // Função para aplicar filtros
  const agendamentosFiltrados = agendamentos.filter(agendamento => {
    const cliente = clientes.find(c => c.id === agendamento.clienteId);
    const colaborador = colaboradores.find(c => c.id === agendamento.colaboradorId);
    const local = locais.find(l => l.id === agendamento.localId);
    const nomeCliente = (cliente && cliente.nome_completo && cliente.nome_completo.toLowerCase()) || '';
    const nomeColaborador = (colaborador && colaborador.nome_completo && colaborador.nome_completo.toLowerCase()) || '';
    const nomeLocal = (local && local.nome && local.nome.toLowerCase()) || '';
    const filtroCliente = filtros.cliente.toLowerCase();
    const filtroColaborador = filtros.colaborador.toLowerCase();
    const filtroLocal = filtros.local.toLowerCase();

      // Filtro por data atual
    const dataAgendamento = new Date(agendamento.dataHoraInicio);
    const dataAtual = new Date();
    const mesmoDia = dataAgendamento.getDate() === dataAtual.getDate() &&
        dataAgendamento.getMonth() === dataAtual.getMonth() &&
        dataAgendamento.getFullYear() === dataAtual.getFullYear();

      return (
        mesmoDia &&
        (filtroCliente === '' || nomeCliente.includes(filtroCliente)) &&
        (filtroColaborador === '' || nomeColaborador.includes(filtroColaborador)) &&
        (filtroLocal === '' || nomeLocal.includes(filtroLocal))
      );
    });

    // Ordenação
  const agendamentosOrdenados = agendamentosFiltrados.sort((a, b) => {
    const isAsc = order === "asc";
      if (orderBy === "cliente") {
      const clienteA = clientes.find(c => c.id === a.clienteId);
      const clienteB = clientes.find(c => c.id === b.clienteId);
      const nomeA = (clienteA && clienteA.nome_completo) || '';
      const nomeB = (clienteB && clienteB.nome_completo) || '';
        return isAsc ? nomeA.localeCompare(nomeB) : nomeB.localeCompare(nomeA);
      }
      if (orderBy === "colaborador") {
      const colaboradorA = colaboradores.find(c => c.id === a.colaboradorId);
      const colaboradorB = colaboradores.find(c => c.id === b.colaboradorId);
      const nomeA = (colaboradorA && colaboradorA.nome_completo) || '';
      const nomeB = (colaboradorB && colaboradorB.nome_completo) || '';
        return isAsc ? nomeA.localeCompare(nomeB) : nomeB.localeCompare(nomeA);
      }
      if (orderBy === "local") {
      const localA = locais.find(l => l.id === a.localId);
      const nomeA = (localA && localA.nome) || '';
      const localB = locais.find(l => l.id === b.localId);
      const nomeB = (localB && localB.nome) || '';
        return isAsc ? nomeA.localeCompare(nomeB) : nomeB.localeCompare(nomeA);
      }
      if (orderBy === "dataHoraInicio") {
        return isAsc ?
          new Date(a.dataHoraInicio) - new Date(b.dataHoraInicio) :
          new Date(b.dataHoraInicio) - new Date(a.dataHoraInicio);
      }
      return 0;
    });

    // Paginação
  const agendamentosPaginados = agendamentosOrdenados.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    // Efeito para atualizar horários quando o serviço muda
    useEffect(() => {
      if (dataSelecionada && formData.servicoId) {
      const dia = dataSelecionada.getDay();
      const horarios = calcularHorariosDisponiveis(dia, formData.servicoId);
        setHorariosDisponiveis(horarios);
      }
    }, [formData.servicoId, dataSelecionada, calcularHorariosDisponiveis]);

    // Função para buscar colaboradores do serviço
  const buscarColaboradoresServico = async (servicoId) => {
      if (!servicoId) {
        setColaboradoresServico([]);
        return;
      }

      try {
      const res = await api.get(`/servico-colaboradores/${servicoId}`);

        if (res.data && Array.isArray(res.data)) {
          // Mapeia os colaboradores retornados
        const colaboradoresDoServico = res.data.map(colaborador => ({
            id: colaborador.id,
            nome_completo: colaborador.nome_completo || colaborador.nome
          }));
          setColaboradoresServico(colaboradoresDoServico);
        } else if (res.data && res.data.colaboradores && Array.isArray(res.data.colaboradores)) {
          // Caso a resposta venha em um objeto com propriedade colaboradores
        const colaboradoresDoServico = res.data.colaboradores.map(colaborador => ({
            id: colaborador.id,
            nome_completo: colaborador.nome_completo || colaborador.nome
          }));
          setColaboradoresServico(colaboradoresDoServico);
        } else {
          setColaboradoresServico([]);
        }
      } catch (err) {
        addError(`Erro ao buscar colaboradores do serviço: ${err.message}`);
        setColaboradoresServico([]);
      }
    };

    // Atualiza a lista de colaboradores quando o serviço muda
    useEffect(() => {
      if (formData.servicoId) {
        buscarColaboradoresServico(formData.servicoId);
      } else {
        setColaboradoresServico([]);
      }
      // Limpa o colaborador selecionado quando o serviço muda
      setFormData(prev => ({ ...prev, colaboradorId: '' }));
      setDisponibilidadeColaborador([]);
      setDiasSelecionados([]);
      setDataSelecionada(null);
      setHorariosDisponiveis([]);
    }, [formData.servicoId]);

    useEffect(() => {
      const timer = setInterval(() => {
        setDataHoraAtual(new Date());
      }, 1000);

      return () => clearInterval(timer);
    }, []);

    const formatarDataHora = (data) => {
      return data.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    };

    const visualizarAgendamento = (agendamento) => {
      setAgendamentoVisualizar(agendamento);
      setActiveTab(0);
      setOpenView(true);
    };

    const fecharVisualizacao = () => {
      setOpenView(false);
      setAgendamentoVisualizar(null);
    };

    const handleTabChange = (event, newValue) => {
      setActiveTab(newValue);
    };

    return (
      <AcessoRestrito modulo="atendimentoindividual">
        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {/* Notificações */}
          <Snackbar 
            open={!!error} 
            autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
            onClose={() => setError(null)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
              {error}
            </Alert>
          </Snackbar>

          <Snackbar 
            open={!!success} 
            autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
            onClose={() => setSuccess(null)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
              {success}
            </Alert>
          </Snackbar>
          
          {/* Box interno com margens de 1,5% */}
          <Box sx={{
            margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
            height: '90vh',
            display: 'flex',
            flexDirection: 'column'
          }}>

            {/* Header */}
            <Box sx={{ 
              p: { xs: 2, sm: 3 }, 
              pb: 2,
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: { xs: 'flex-start', sm: 'center' },
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 2, sm: 0 }
            }}>
              <Typography 
                variant="h5" 
                mb={1} 
                sx={{ 
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <PersonIcon sx={{ 
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  color: '#FFC107' // Mesma cor usada no menu lateral
                }} />
                Atendimento ao Cliente
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Exibindo apenas agendamentos de hoje ({new Date().toLocaleDateString('pt-BR')})
              </Typography>
            </Box>

            {/* Container da Tabela */}
            <TableContainer 
              component={Paper} 
              sx={{ 
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                overflow: 'auto',
                height: '100%',
                maxHeight: '100%',
                width: '100%',
                minWidth: '100%',
                maxWidth: '100%',
                boxShadow: (theme) => theme.palette.mode === 'dark' 
                  ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
                  : '0 2px 8px rgba(0, 0, 0, 0.06)',
                borderRadius: 1,
                border: 'none'
              }}
            >
        <Table sx={{ minWidth: 650, tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell width="22%">
                <TableSortLabel
                  active={orderBy === "cliente"}
                  direction={orderBy === "cliente" ? order : "asc"}
                  onClick={() => handleRequestSort("cliente")}
                >
                  Cliente
                </TableSortLabel>
                <TextField
                  name="cliente"
                  size="small"
                  fullWidth
                  value={filtros.cliente}
                  onChange={handleFiltroChange}
                  placeholder="Filtrar por cliente"
                />
              </TableCell>
              <TableCell width="22%">
                <TableSortLabel
                  active={orderBy === "colaborador"}
                  direction={orderBy === "colaborador" ? order : "asc"}
                  onClick={() => handleRequestSort("colaborador")}
                >
                  Colaborador
                </TableSortLabel>
                <TextField
                  name="colaborador"
                  size="small"
                  fullWidth
                  value={filtros.colaborador}
                  onChange={handleFiltroChange}
                  placeholder="Filtrar por colaborador"
                />
              </TableCell>
              <TableCell width="18%">
                <TableSortLabel
                  active={orderBy === "local"}
                  direction={orderBy === "local" ? order : "asc"}
                  onClick={() => handleRequestSort("local")}
                >
                  Local
                </TableSortLabel>
                <TextField
                  name="local"
                  size="small"
                  fullWidth
                  value={filtros.local}
                  onChange={handleFiltroChange}
                  placeholder="Filtrar por local"
                />
              </TableCell>
              <TableCell width="13%">
                <TableSortLabel
                  active={orderBy === "dataHoraInicio"}
                  direction={orderBy === "dataHoraInicio" ? order : "asc"}
                  onClick={() => handleRequestSort("dataHoraInicio")}
                >
                  Data/Hora
                </TableSortLabel>
              </TableCell>
              <TableCell width="12%">Ação</TableCell>
              <TableCell width="10%">
                <TableSortLabel
                  active={orderBy === "senha"}
                  direction={orderBy === "senha" ? order : "asc"}
                  onClick={() => handleRequestSort("senha")}
                >
                  Senha
                </TableSortLabel>
              </TableCell>
              <TableCell width="8%">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : agendamentosPaginados.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  Nenhum agendamento encontrado.
                </TableCell>
              </TableRow>
            ) : (
              agendamentosPaginados.map((agendamento) => {
                // Verifica se o agendamento é passado
              const dataHoraAgendamento = new Date(agendamento.dataHoraInicio);
              const dataHoraAtual = new Date();
              const isAgendamentoPassado = dataHoraAgendamento < dataHoraAtual;

                return (
                  <TableRow
                    key={agendamento._id}
                  >
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {(() => {
                        const cliente = clientes.find(c => c.id === agendamento.clienteId);
                        return (cliente && cliente.nome_completo) || agendamento.clienteId;
                      })()}
                    </TableCell>
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {(() => {
                        const colaborador = colaboradores.find(c => c.id === agendamento.colaboradorId);
                        return (colaborador && colaborador.nome_completo) || agendamento.colaboradorId;
                      })()}
                    </TableCell>
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {(() => {
                      const local = locais.find(l => l.id === agendamento.localId);
                        return (local && local.nome) || agendamento.localId;
                      })()}
                    </TableCell>
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {format(parseISO(agendamento.dataHoraInicio), 'dd/MM/yyyy HH:mm', { locale: ptBR })} - {format(parseISO(agendamento.dataHoraFim), 'HH:mm', { locale: ptBR })}
                    </TableCell>
                    <TableCell>
                      {(() => {
                      const temAtendimento = verificarAtendimentoExistente(agendamento._id);
                      const statusAtendimento = obterStatusAtendimento(agendamento._id);
                      const isBloqueado = isAtendimentoBloqueado(agendamento._id);

                        // Se o atendimento está bloqueado, mostra o status
                        if (isBloqueado && statusAtendimento) {
                          return (
                            <Button
                              variant="contained"
                              size="small"
                              disabled={true}
                              sx={{
                                minWidth: '100px',
                                fontSize: '0.75rem',
                                textTransform: 'none',
                                backgroundColor: '#9e9e9e',
                                color: '#fff',
                                cursor: 'not-allowed',
                                '&:hover': {
                                  backgroundColor: '#9e9e9e',
                                }
                              }}
                            >
                              {statusAtendimento}
                            </Button>
                          );
                        }

                        if (statusAtendimento === 'Chamando' || statusAtendimento === 'Em atendimento') {
                          return (
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleOpenFormularioAtendimento(agendamento)}
                              sx={{
                                minWidth: '100px',
                                fontSize: '0.75rem',
                                textTransform: 'none',
                                backgroundColor: '#1976d2',
                                color: '#fff',
                                '&:hover': { backgroundColor: '#1565c0' }
                              }}
                            >
                              {statusAtendimento}
                            </Button>
                          );
                        }

                        // Somente um atendimento efetivamente aguardando pode ser chamado.
                        if (temAtendimento && statusAtendimento === 'Aguardando') {
                          return (
                            <Button
                              variant="contained"
                              size="small"
                              color="warning"
                              onClick={() => handleAbrirAtendimentoEChamar(agendamento)}
                              disabled={loading}
                              sx={{
                                minWidth: '100px',
                                fontSize: '0.75rem',
                                textTransform: 'none',
                                backgroundColor: '#ffeb3b',
                                color: '#1976d2',
                                '&:hover': {
                                  backgroundColor: '#fdd835',
                                }
                              }}
                            >
                              Aguardando
                            </Button>
                          );
                        }

                        if (temAtendimento && statusAtendimento) {
                          return (
                            <Button variant="contained" size="small" disabled sx={{ minWidth: '100px', fontSize: '0.75rem', textTransform: 'none' }}>
                              {statusAtendimento}
                            </Button>
                          );
                        }

                        // Se não tem atendimento, mostra "Confirmar"
                        return (
                          <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={() => handleConfirmarAtendimento(agendamento)}
                            sx={{
                              minWidth: '100px',
                              fontSize: '0.75rem',
                              textTransform: 'none'
                            }}
                          >
                            Confirmar
                          </Button>
                        );
                      })()}
                    </TableCell>
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {(() => {
                      const atendimento = atendimentos.find(a => a.agendamentoId === agendamento._id);
                        return atendimento && atendimento.ordem_chegada || '';
                      })()}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="Visualizar">
                          <IconButton size="small" onClick={() => handleVisualizarAtendimento(agendamento)}>
                            <VisibilityIcon fontSize="small" className="material-icon-visibility" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                          <IconButton size="small" onClick={() => handleOpenForm(agendamento)}>
                            <EditIcon fontSize="small" className="material-icon-edit" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Excluir">
                          <IconButton size="small" onClick={() => handleOpenDelete(agendamento)}>
                            <DeleteIcon fontSize="small" className="material-icon-delete" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

            {/* Paginação Fixa */}
            <TablePagination
              component="div"
              count={agendamentosFiltrados.length}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
              rowsPerPageOptions={[5, 10, 25]}
              labelRowsPerPage="Itens por página"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
              sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: 'background.paper',
                borderTop: 1,
                borderColor: 'divider',
                width: '100%',
                px: 3,
                py: 1.5,
                boxSizing: 'border-box',
                zIndex: 1000,
                minHeight: '60px'
              }}
            />
          </Box>

      {/* Formulário */}
      <Dialog
        open={openForm}
        onClose={handleCloseForm}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            overflowY: 'auto'
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          {agendamentoSelecionado ? "Editar Agendamento" : "Novo Agendamento"}
        </DialogTitle>
        <DialogContent sx={{
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px',
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          }
        }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* 1. Seleção de Cliente */}
            <FormControl fullWidth error={formErrors.clienteId}>
              <InputLabel>Cliente</InputLabel>
              <Select
                name="clienteId"
                value={formData.clienteId}
                onChange={handleClienteChange}
                label="Cliente"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300
                    }
                  },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                  }
                }}
              >
                {clientes.map((cliente) => (
                  <MenuItem
                    key={cliente.id}
                    value={cliente.id}
                    sx={{
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      py: 1
                    }}
                  >
                    {cliente.nome_completo || cliente.nome}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.clienteId && (
                <FormHelperText error>Cliente é obrigatório</FormHelperText>
              )}
            </FormControl>

            {/* 2 e 3. CPF/CNPJ e Data de Nascimento */}
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                sx={{ width: '50%' }}
                label="CPF/CNPJ"
                value={(clienteSelecionado && clienteSelecionado.cpf_cnpj) || ''}
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '& .MuiInputBase-input': {
                      color: 'rgba(0, 0, 0, 0.6)'
                    }
                  }
                }}
              />
              <TextField
                sx={{ width: '50%' }}
                label="Data de Nascimento"
                value={(clienteSelecionado && clienteSelecionado.data_nascimento) ? format(new Date(clienteSelecionado.data_nascimento), 'dd/MM/yyyy') : ''}
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '& .MuiInputBase-input': {
                      color: 'rgba(0, 0, 0, 0.6)'
                    }
                  }
                }}
              />
            </Box>

            {/* 4. Observação */}
            <TextField
              fullWidth
              label="Observação"
              value={(clienteSelecionado && clienteSelecionado.observacao) || ''}
              multiline
              rows={2}
              InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  '& .MuiInputBase-input': {
                    color: 'rgba(0, 0, 0, 0.6)'
                  }
                }
              }}
            />

            {/* 5 e 6. RG e Gênero */}
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                sx={{ width: '50%' }}
                label="RG"
                value={(clienteSelecionado && clienteSelecionado.rg) || ''}
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '& .MuiInputBase-input': {
                      color: 'rgba(0, 0, 0, 0.6)'
                    }
                  }
                }}
              />
              <TextField
                sx={{ width: '50%' }}
                label="Gênero"
                value={(clienteSelecionado && clienteSelecionado.genero) || ''}
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '& .MuiInputBase-input': {
                      color: 'rgba(0, 0, 0, 0.6)'
                    }
                  }
                }}
              />
            </Box>

            {/* 7. Serviço e Duração */}
            <Box sx={{ display: 'flex', gap: 2 }}>
              <FormControl sx={{ width: '80%' }} error={formErrors.servicoId}>
                <InputLabel>Serviço</InputLabel>
                <Select
                  name="servicoId"
                  value={formData.servicoId}
                  onChange={handleInputChange}
                  label="Serviço"
                >
                  {servicos.map((servico) => (
                    <MenuItem key={servico.id} value={servico.id}>
                      {servico.nome} - {servico.categoria} ({servico.duracao_minutos} min)
                    </MenuItem>
                  ))}
                </Select>
                {formErrors.servicoId && (
                  <FormHelperText error>Serviço é obrigatório</FormHelperText>
                )}
              </FormControl>

              <TextField
                sx={{ width: '20%' }}
                label="Duração"
                value={formData.servicoId ? (() => {
                const servico = servicos.find(s => s.id === formData.servicoId);
                  return `${(servico && servico.duracao_minutos) || 0} minutos`;
                })() : ''}
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '& .MuiInputBase-input': {
                      color: 'rgba(0, 0, 0, 0.6)'
                    }
                  }
                }}
              />
            </Box>

            {/* 8. Seleção de Local */}
            <Box sx={{ display: 'flex', gap: 2 }}>
              <FormControl sx={{ width: '20%' }}>
                <InputLabel>Local</InputLabel>
                <Select
                  name="local_execucao"
                  value={formData.local_execucao.tipo || ''}
                  label="Local"
                  disabled={true}
                >
                  {formData.servicoId && (() => {
                  const servico = servicos.find(s => s.id === formData.servicoId);
                    return servico && servico.local_execucao;
                  })() ? (
                    <MenuItem
                      key="servico-local"
                      value={servicos.find(s => s.id === formData.servicoId).local_execucao.tipo}
                    >
                      {servicos.find(s => s.id === formData.servicoId).local_execucao.tipo === 'presencial' ? 'Presencial' :
                        servicos.find(s => s.id === formData.servicoId).local_execucao.tipo === 'online' ? 'Online' : 'Híbrido'}
                    </MenuItem>
                  ) : (
                    <div>
                      <MenuItem key="online" value="online">Online</MenuItem>
                      <MenuItem key="presencial" value="presencial">Presencial</MenuItem>
                      <MenuItem key="hibrido" value="hibrido">Híbrido</MenuItem>
                    </div>
                  )}
                </Select>
              </FormControl>

              <TextField
                sx={{ width: '80%' }}
                label="Endereço do Local"
                value={(() => {
                  if (formData.servicoId) {
                  const servico = servicos.find(s => s.id === formData.servicoId);
                    return (servico && servico.local_execucao && servico.local_execucao.local) || formData.local_execucao.local || '';
                  }
                  return formData.local_execucao.local || '';
                })()}
                disabled={true}
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '& .MuiInputBase-input': {
                      color: 'rgba(0, 0, 0, 0.6)'
                    }
                  }
                }}
              />
            </Box>
            {!formData.servicoId && (
              <FormHelperText>Selecione um serviço primeiro</FormHelperText>
            )}

            {/* 9. Seleção de Colaborador */}
            <FormControl fullWidth error={formErrors.colaboradorId}>
              <InputLabel>Colaborador</InputLabel>
              <Select
                name="colaboradorId"
                value={formData.colaboradorId}
                onChange={handleColaboradorChange}
                label="Colaborador"
                disabled={!formData.servicoId}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300
                    }
                  }
                }}
              >
                {colaboradoresServico.length > 0 ? (
                  colaboradoresServico.map((colaborador) => (
                    <MenuItem
                      key={colaborador.id}
                      value={colaborador.id}
                      sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        py: 1
                      }}
                    >
                      {colaborador.nome_completo}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>
                    {formData.servicoId ? 'Nenhum colaborador disponível' : 'Selecione um serviço primeiro'}
                  </MenuItem>
                )}
              </Select>
              {formErrors.colaboradorId && (
                <FormHelperText error>Colaborador é obrigatório</FormHelperText>
              )}
              {!formData.servicoId && (
                <FormHelperText>Selecione um serviço primeiro</FormHelperText>
              )}
            </FormControl>

            {/* 10 e 11. Disponibilidade e Calendário */}
            <Box sx={{ display: 'flex', gap: 2 }}>
              {/* Disponibilidade do Colaborador */}
              <Box sx={{ width: '50%' }}>
                <Typography variant="subtitle1" gutterBottom>
                  Disponibilidade do Colaborador
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {formData.colaboradorId ? (
                    disponibilidadeColaborador.length > 0 ? (
                      disponibilidadeColaborador.map((disp) => (
                        <Chip
                          key={disp.dia}
                          label={`${diasSemana[disp.dia]}: ${disp.inicio} - ${disp.fim}`}
                          onClick={() => handleDiaSelecionado(disp.dia)}
                          color={diasSelecionados.includes(disp.dia) ? 'primary' : 'default'}
                          sx={{ width: '100%', justifyContent: 'flex-start' }}
                        />
                      ))
                    ) : (
                      <Typography color="text.secondary">
                        Nenhuma disponibilidade cadastrada para este colaborador
                      </Typography>
                    )
                  ) : (
                    <Typography color="text.secondary">
                      Selecione um colaborador para ver sua disponibilidade
                    </Typography>
                  )}
                </Box>
                {formErrors.diasSelecionados && (
                  <FormHelperText error>Selecione pelo menos um dia</FormHelperText>
                )}
              </Box>

              {/* Seleção de Data */}
              <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column' }}>
                <Typography variant="subtitle1" gutterBottom>
                  Data
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DesktopDatePicker
                    label="Selecione a data"
                    value={dataSelecionada}
                    onChange={handleDataChange}
                    shouldDisableDate={(date) => {
                    const diaSemana = date.getDay();
                    const hoje = new Date();
                      hoje.setHours(0, 0, 0, 0); // Remove horas para comparar apenas a data

                      // Desabilita datas passadas
                      if (date < hoje) {
                        return true;
                      }

                      // Desabilita dias da semana não disponíveis
                      return !diasSelecionados.includes(diaSemana);
                    }}
                    disabled={!formData.colaboradorId || diasSelecionados.length === 0}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        error={formErrors.dataSelecionada}
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true
                        }}
                        helperText={
                          formErrors.dataSelecionada
                            ? "Data é obrigatória"
                            : !formData.colaboradorId
                              ? "Selecione um colaborador"
                              : diasSelecionados.length === 0
                                ? "Selecione os dias disponíveis"
                                : ""
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>
            </Box>

            {/* 12. Horários Disponíveis */}
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                Horários Disponíveis
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {horariosDisponiveis.map((horario) => (
                  <Chip
                    key={horario.horario}
                    label={horario.horario}
                    onClick={() => {
                      if (!horario.disponivel) return; // Não permite clique em horários ocupados

                    const [hora, minuto] = horario.horario.split(':');
                    const dataHoraInicio = new Date(dataSelecionada);
                      dataHoraInicio.setHours(parseInt(hora));
                      dataHoraInicio.setMinutes(parseInt(minuto));
                      dataHoraInicio.setSeconds(0);
                      dataHoraInicio.setMilliseconds(0);

                      // Salva o horário como string local com timezone offset
                    const ano = dataHoraInicio.getFullYear();
                    const mes = String(dataHoraInicio.getMonth() + 1).padStart(2, '0');
                    const dia = String(dataHoraInicio.getDate()).padStart(2, '0');
                    const horaStr = String(dataHoraInicio.getHours()).padStart(2, '0');
                    const minutoStr = String(dataHoraInicio.getMinutes()).padStart(2, '0');
                    const segundoStr = String(dataHoraInicio.getSeconds()).padStart(2, '0');

                      // Calcula o timezone offset local
                    const tzOffset = -new Date().getTimezoneOffset(); // ex: -180 minutos
                    const offsetSign = tzOffset >= 0 ? '+' : '-';
                    const offsetHours = String(Math.floor(Math.abs(tzOffset) / 60)).padStart(2, '0');
                    const offsetMinutes = String(Math.abs(tzOffset) % 60).padStart(2, '0');
                    const timezoneOffset = `${offsetSign}${offsetHours}:${offsetMinutes}`;

                    const dataHoraString = `${ano}-${mes}-${dia}T${horaStr}:${minutoStr}:${segundoStr}${timezoneOffset}`;

                      setFormData(prev => ({
                        ...prev,
                        dataHoraInicio: dataHoraString
                      }));
                    }}
                    color={
                      !horario.disponivel
                        ? 'error'
                        : formData.dataHoraInicio && format(new Date(formData.dataHoraInicio), 'HH:mm') === horario.horario
                          ? 'primary'
                          : 'default'
                    }
                    disabled={!horario.disponivel}
                    sx={{
                      opacity: horario.disponivel ? 1 : 0.7,
                      cursor: horario.disponivel ? 'pointer' : 'not-allowed'
                    }}
                  />
                ))}
              </Box>
              {formErrors.dataHoraInicio && (
                <FormHelperText error>Selecione um horário</FormHelperText>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          },
          '& .MuiTypography-root': {
            fontSize: '0.875rem'
          }
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false
            })}
          </Typography>
          <Box>
            <Button
              onClick={handleCloseForm}
              variant="contained"
              color="primary"
            >
              FECHAR
            </Button>
            <Button
              onClick={handleConfirmarSalvar}
              variant="contained"
              color="primary"
              disabled={loading}
              sx={{ ml: 1 }}
            >
              {loading ? <CircularProgress size={24} /> : "SALVAR"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Confirmação de exclusão */}
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2
        }}>
          Confirmar Exclusão
        </DialogTitle>
        <DialogContent sx={{ padding: 2 }}>
          <Typography>
            Tem certeza que deseja excluir este agendamento?
          </Typography>
        </DialogContent>
        <DialogActions sx={{
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          padding: 2
        }}>
          <Button onClick={handleCloseDelete}>Cancelar</Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirmarExcluir}
            disabled={loading}
          >
            Excluir
          </Button>
        </DialogActions>
      </Dialog>

      {/* Formulário de Atendimento */}
      <Dialog
        open={openAtendimento}
        onClose={handleCloseAtendimento}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            height: '550px',
            overflowY: 'auto'
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Atendimento - {(() => {
            if (agendamentoAtendimento) {
              const cliente = clientes.find(c => c.id === agendamentoAtendimento.clienteId);
              return (cliente && cliente.nome_completo) || 'Cliente';
            }
            return 'Cliente';
          })()}
        </DialogTitle>
        <DialogContent sx={{
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px',
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          }
        }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs value={activeTabAtendimento} onChange={handleTabChangeAtendimento}>
              <Tab label="Agenda" />
              <Tab label="Atendimento" />
            </Tabs>
          </Box>

          {activeTabAtendimento === 0 && agendamentoAtendimento && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Cliente"
                    value={(() => {
                      const cliente = clientes.find(c => c.id === agendamentoAtendimento.clienteId);
                      return (cliente && cliente.nome_completo) || '';
                    })()}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="CPF/CNPJ"
                    value={(() => {
                    const cliente = clientes.find(c => c.id === agendamentoAtendimento.clienteId);
                      return (cliente && cliente.cpf_cnpj) ? formatarCPFCNPJLGPD(cliente.cpf_cnpj, cliente.tipo_pessoa, true) : '';
                    })()}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Endereço Completo"
                    value={(() => {
                    const cliente = clientes.find(c => c.id === agendamentoAtendimento.clienteId);
                      if (!cliente) return '';
                    const endereco = [
                        cliente.logradouro,
                        cliente.numero,
                        cliente.complemento,
                        cliente.bairro,
                        cliente.cidade,
                        cliente.estado
                      ].filter(Boolean).join(', ');
                      return endereco || 'Endereço não informado';
                    })()}
                    disabled
                    multiline
                    rows={2}
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Telefone"
                    value={(() => {
                    const cliente = clientes.find(c => c.id === agendamentoAtendimento.clienteId);
                      return (cliente && cliente.celular) ? formatarTelefoneLGPD(cliente.celular, true) :
                        (cliente && cliente.telefone_fixo) ? formatarTelefoneLGPD(cliente.telefone_fixo, true) : '';
                    })()}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={(() => {
                    const cliente = clientes.find(c => c.id === agendamentoAtendimento.clienteId);
                      return (cliente && cliente.email) ? formatarEmailLGPD(cliente.email, true) : '';
                    })()}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Colaborador"
                    value={(() => {
                      const colaborador = colaboradores.find(c => c.id === agendamentoAtendimento.colaboradorId);
                      return (colaborador && colaborador.nome_completo) || '';
                    })()}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Local"
                    value={(() => {
                    const local = locais.find(l => l.id === agendamentoAtendimento.localId);
                      return (local && local.nome) || '';
                    })()}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Serviço"
                    value={(() => {
                    const servico = servicos.find(s => s.id === agendamentoAtendimento.servicoId);
                      return (servico && servico.nome) || '';
                    })()}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Data/Hora Início"
                    value={agendamentoAtendimento.dataHoraInicio ? format(parseISO(agendamentoAtendimento.dataHoraInicio), 'dd/MM/yyyy HH:mm', { locale: ptBR }) : ''}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Data/Hora Fim"
                    value={agendamentoAtendimento.dataHoraFim ? format(parseISO(agendamentoAtendimento.dataHoraFim), 'dd/MM/yyyy HH:mm', { locale: ptBR }) : ''}
                    disabled
                    inputProps={{
                      sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}

          {activeTabAtendimento === 1 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Typography variant="h6" color="text.secondary">
                Área de Atendimento
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Esta área está disponível para registrar informações do atendimento.
              </Typography>
              {/* Aqui você pode adicionar os campos específicos do atendimento */}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          },
          '& .MuiTypography-root': {
            fontSize: '0.875rem'
          }
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false
            })}
          </Typography>
          <Box>
            <Button
              onClick={handleCloseAtendimento}
              variant="contained"
              color="primary"
            >
              FECHAR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Modal do Formulário de Atendimento */}
      <Dialog
        open={openFormularioAtendimento}
        onClose={handleCloseFormularioAtendimento}
        maxWidth={false}
        PaperProps={{
          sx: {
            height: '600px',
            width: '85%',
            maxWidth: '1200px',
            overflowY: 'auto'
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1976d2' : '#e3f2fd',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Formulário de Atendimento
        </DialogTitle>
        <DialogContent sx={{
          padding: 3,
          height: 'calc(600px - 140px)',
          overflowY: 'auto',
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          }
        }}>
          {atendimentoSelecionado && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={activeTabFormularioAtendimento}
                  onChange={handleTabChangeFormularioAtendimento}
                  sx={{ minHeight: '48px' }}
                >
                  <Tab label="Informações" />
                  <Tab label="HISTÓRICO" />
                  <Tab label="ATENDIMENTO" />
                </Tabs>
              </Box>

              {activeTabFormularioAtendimento === 0 && (
                <div>
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    Informações do Atendimento
                  </Typography>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <TextField
                        fullWidth
                        label="Cliente"
                        value={(() => {
                          const cliente = clientes.find(c => c.id === atendimentoSelecionado.clienteId);
                          return (cliente && cliente.nome_completo) || '';
                        })()}
                        disabled
                        InputProps={{
                          sx: { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                      />
                      <TextField
                        fullWidth
                        label="Status Atual"
                        value={atendimentoSelecionado.status || 'Aguardando'}
                        disabled
                        InputProps={{
                          sx: { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                      />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <TextField
                        fullWidth
                        label="Colaborador"
                        value={(() => {
                          const colaborador = colaboradores.find(c => c.id === atendimentoSelecionado.colaboradorId);
                          return (colaborador && colaborador.nome_completo) || '';
                        })()}
                        disabled
                        InputProps={{
                          sx: { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                      />
                      <TextField
                        fullWidth
                        label="Serviço"
                        value={(() => {
                        const servico = servicos.find(s => s.id === atendimentoSelecionado.servicoId);
                          return (servico && servico.nome) || '';
                        })()}
                        disabled
                        InputProps={{
                          sx: { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                      />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <TextField
                        fullWidth
                        label="Senha"
                        value={atendimentoSelecionado.ordem_chegada || ''}
                        disabled
                        InputProps={{
                          sx: { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                      />
                      <TextField
                        fullWidth
                        label="Horário Agendado"
                        value={atendimentoSelecionado.dataHoraInicio ? format(parseISO(atendimentoSelecionado.dataHoraInicio), 'dd/MM/yyyy HH:mm', { locale: ptBR }) : ''}
                        disabled
                        InputProps={{
                          sx: { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                      />
                    </Box>
                  </Box>
                </div>
              )}

              {activeTabFormularioAtendimento === 1 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {/* Histórico */}
                  <Box>
                    <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                      Histórico
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={18}
                      value={formatarHistoricoOcorrencias()}
                      disabled
                      InputProps={{
                        sx: {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          fontFamily: 'monospace',
                          fontSize: '0.8rem'
                        }
                      }}
                      placeholder="Histórico de ocorrências..."
                    />
                  </Box>
                </Box>
              )}

              {activeTabFormularioAtendimento === 2 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {/* Tipo da anotação de atendimento */}
                  <Box>
                    <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                      Tipo
                    </Typography>
                    <FormControl fullWidth>
                      <InputLabel>Tipo</InputLabel>
                      <Select
                        name="tipoAnotacao"
                        value={formDataAnotacao.tipoAnotacao || ''}
                        onChange={e => setFormDataAnotacao(prev => ({ ...prev, tipoAnotacao: e.target.value }))}
                        label="Tipo"
                        disabled={isModoVisualizacao || (atendimentoSelecionado && atendimentoSelecionado.status) !== "Aguardando"}
                      >
                        {tiposAnotacoes.map((tipo) => (
                          <MenuItem key={tipo.value} value={tipo.value}>
                            {tipo.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  {/* Anotações de atendimento */}
                  <Box>
                    <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                      Anotações
                    </Typography>
                      <TextField
                      fullWidth
                      multiline
                      rows={8}
                      name="anotacao"
                      value={formDataAnotacao.anotacao || ''}
                      onChange={e => setFormDataAnotacao(prev => ({ ...prev, anotacao: e.target.value }))}
                      placeholder="Digite as anotações do atendimento aqui..."
                      disabled={isModoVisualizacao || (atendimentoSelecionado && atendimentoSelecionado.status) !== "Aguardando"}
                      inputProps={{
                        maxLength: 60000
                      }}
                      InputProps={{
                        sx: {
                          fontSize: '0.875rem',
                          '& .MuiInputBase-input': {
                            fontSize: '0.875rem'
                          }
                        }
                      }}
                      helperText={`${(formDataAnotacao.anotacao || '').length}/60.000 caracteres`}
                    />
                  </Box>

                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{
          padding: 2,
          borderTop: 1,
          borderColor: 'divider',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          width: '100%'
        }}>
          {activeTabFormularioAtendimento === 2 && !isModoVisualizacao && (
            <Typography variant="subtitle2" color="text.secondary" sx={{ alignSelf: 'flex-start', mb: 1 }}>
              Alterar o status do atendimento
            </Typography>
          )}
          <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
            {activeTabFormularioAtendimento === 2 && !isModoVisualizacao && (
              <div>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => handleConfirmarAtualizarStatus("Atendido")}
                  disabled={loading || !['Aguardando', 'Chamando', 'Em atendimento'].includes(atendimentoSelecionado?.status)}
                  sx={{ flex: 1, minWidth: 0 }}
                >
                  {loading ? <CircularProgress size={20} /> : "Atendido"}
                </Button>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={() => handleConfirmarAtualizarStatus("Desistente")}
                  disabled={loading || !['Aguardando', 'Chamando', 'Em atendimento'].includes(atendimentoSelecionado?.status)}
                  sx={{ flex: 1, minWidth: 0 }}
                >
                  {loading ? <CircularProgress size={20} /> : "Desistente"}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleConfirmarAtualizarStatus("Cancelado")}
                  disabled={loading || !['Aguardando', 'Chamando', 'Em atendimento'].includes(atendimentoSelecionado?.status)}
                  sx={{ flex: 1, minWidth: 0 }}
                >
                  {loading ? <CircularProgress size={20} /> : "Cancelar"}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmarSalvarAnotacao}
                  disabled={!formDataAnotacao.tipoAnotacao || !formDataAnotacao.anotacao || loading || !['Aguardando', 'Chamando', 'Em atendimento'].includes(atendimentoSelecionado?.status)}
                  sx={{ flex: 1, minWidth: 0 }}
                >
                  {loading ? <CircularProgress size={20} /> : "Salvar Anotações"}
                </Button>
              </div>
            )}
            {activeTabFormularioAtendimento === 2 && !isModoVisualizacao && (
              <Button
                variant="contained"
                color="secondary"
                onClick={handleConfirmarImprimir}
                disabled={!['Aguardando', 'Chamando', 'Em atendimento'].includes(atendimentoSelecionado?.status)}
                sx={{ flex: 1, minWidth: 0 }}
              >
                Imprimir
              </Button>
            )}
            <Button
              onClick={handleCloseFormularioAtendimento}
              variant="outlined"
              sx={{ flex: 1, minWidth: 0 }}
            >
              Fechar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Visualização */}
      <Dialog 
        open={openView} 
        onClose={fecharVisualizacao} 
        maxWidth="md" 
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            overflowY: 'auto',
            width: '900px',
            height: '550px'
          }
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          Visualizar Agendamento
          <IconButton onClick={fecharVisualizacao} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px',
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          }
        }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange} 
            sx={{ 
              borderBottom: 1, 
              borderColor: 'divider',
              mb: 2
            }}
          >
            <Tab label="Dados do Agendamento" />
            <Tab label="Data e Horário" />
            <Tab label="Configurações" />
          </Tabs>

          {activeTab === 0 && agendamentoVisualizar && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                fullWidth
                label="Cliente"
                value={clientes.find(c => c.id === agendamentoVisualizar.clienteId)?.nome_completo || ''}
                disabled
              />
              <TextField
                fullWidth
                label="Colaborador"
                value={colaboradores.find(c => c.id === agendamentoVisualizar.colaboradorId)?.nome_completo || ''}
                disabled
              />
              <TextField
                fullWidth
                label="Local"
                value={locais.find(l => l.id === agendamentoVisualizar.localId)?.nome || ''}
                disabled
              />
              <TextField
                fullWidth
                label="Serviço"
                value={servicos.find(s => s.id === agendamentoVisualizar.servicoId)?.nome || ''}
                disabled
              />
            </Box>
          )}

          {activeTab === 1 && agendamentoVisualizar && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                fullWidth
                label="Data"
                value={format(parseISO(agendamentoVisualizar.dataHoraInicio), 'dd/MM/yyyy', { locale: ptBR })}
                disabled
              />
              <TextField
                fullWidth
                label="Hora de Início"
                value={format(parseISO(agendamentoVisualizar.dataHoraInicio), 'HH:mm', { locale: ptBR })}
                disabled
              />
              <TextField
                fullWidth
                label="Hora de Fim"
                value={format(parseISO(agendamentoVisualizar.dataHoraFim), 'HH:mm', { locale: ptBR })}
                disabled
              />
            </Box>
          )}

          {activeTab === 2 && agendamentoVisualizar && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                fullWidth
                label="Local de Execução"
                value={agendamentoVisualizar.local_execucao?.tipo || ''}
                disabled
              />
              <TextField
                fullWidth
                label="Observações"
                multiline
                rows={4}
                value={agendamentoVisualizar.observacoes || ''}
                disabled
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          },
          '& .MuiTypography-root': {
            fontSize: '0.875rem'
          }
        }}>
          <Typography variant="body2" color="text.secondary">
            {formatarDataHora(dataHoraAtual)}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {activeTab > 0 && (
              <Button 
                onClick={() => setActiveTab(activeTab - 1)}
                variant="outlined"
                size="small"
              >
                Anterior
              </Button>
            )}
            {activeTab < 2 && (
              <Button 
                onClick={() => setActiveTab(activeTab + 1)}
                variant="outlined"
                size="small"
              >
                Próximo
              </Button>
            )}
            <Button 
              onClick={fecharVisualizacao}
              variant="contained" 
              color="primary"
            >
              FECHAR
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              startIcon={<PrintIcon />}
              onClick={() => {
                if (agendamentoVisualizar) {
                  window.print();
                }
              }}
            >
              IMPRIMIR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Modal de Pagamento */}
      <Dialog
        open={openModalPagamento}
        onClose={handleFecharModalPagamento}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" component="span">
              Configurar Pagamento - Iniciar Atendimento
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 2 }}>
            {/* Forma de Pagamento */}
            <FormControl fullWidth required>
              <InputLabel>Forma de Pagamento</InputLabel>
              <Select
                value={formDataPagamento.formaPagamento}
                onChange={(e) => setFormDataPagamento(prev => ({ ...prev, formaPagamento: e.target.value }))}
                label="Forma de Pagamento"
              >
                {FORMAS_PAGAMENTO.map((forma) => (
                  <MenuItem key={forma} value={forma}>
                    {forma}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Parcelado ou não */}
            <FormControlLabel
              control={
                <Switch
                  checked={formDataPagamento.parcelado}
                  onChange={(e) => setFormDataPagamento(prev => ({ ...prev, parcelado: e.target.checked }))}
                />
              }
              label="Parcelar pagamento"
            />

            {/* Número de Parcelas (só aparece se parcelado) */}
            {formDataPagamento.parcelado && (
              <TextField
                label="Número de Parcelas"
                type="number"
                value={formDataPagamento.numParcelas}
                onChange={(e) => {
                  const num = parseInt(e.target.value) || 1;
                  if (num >= 1) {
                    setFormDataPagamento(prev => ({ ...prev, numParcelas: num }));
                  }
                }}
                inputProps={{ min: 1, max: 12 }}
                helperText="Informe o número de parcelas (máximo 12)"
                fullWidth
                required
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleFecharModalPagamento} variant="outlined">
            Cancelar
          </Button>
          <Button
            onClick={handleProcessarPagamento}
            variant="contained"
            color="primary"
            disabled={!formDataPagamento.formaPagamento || loading}
          >
            {loading ? <CircularProgress size={20} /> : 'Confirmar e Finalizar'}
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
    </AcessoRestrito>
  );
}
